import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ShoppingBag, Minus, Plus, ChevronLeft } from "lucide-react";
import { api, resolveFileUrl } from "../api";
import { useCart } from "../contexts";

export default function ProductDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { addItem } = useCart();
  const [p, setP] = useState(null);
  const [size, setSize] = useState("");
  const [qty, setQty] = useState(1);
  const [added, setAdded] = useState(false);

  useEffect(() => {
    api.get(`/products/${id}`).then((r) => {
      setP(r.data);
      if (r.data.sizes?.length) setSize(r.data.sizes[0]);
    });
  }, [id]);

  if (!p) return <div className="max-w-[1600px] mx-auto p-10 font-mono-label">Loading…</div>;

  const handleAdd = () => {
    addItem(p, qty, size);
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  };

  return (
    <div className="pb-32">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-8">
        <button onClick={() => navigate(-1)} className="font-mono-label text-[11px] text-neutral-400 hover:text-white inline-flex items-center gap-2 mb-6" data-testid="product-back">
          <ChevronLeft size={14} /> BACK
        </button>
        <div className="grid md:grid-cols-2 gap-10">
          <div className="aspect-square overflow-hidden border border-neutral-800">
            <img src={resolveFileUrl(p.image)} alt={p.title} className="w-full h-full object-cover" data-testid="product-image" />
          </div>
          <div>
            <div className="font-mono-label text-[11px] text-[var(--accent)] mb-3">{p.category.toUpperCase()}</div>
            <h1 className="font-display text-4xl md:text-6xl uppercase leading-none mb-3" data-testid="product-title">{p.title}</h1>
            <div className="font-display text-3xl mb-6" data-testid="product-price">${p.price.toFixed(2)}</div>
            <p className="text-neutral-400 mb-8 max-w-lg">{p.description}</p>

            {p.sizes?.length > 0 && (
              <div className="mb-6">
                <div className="font-mono-label text-[10px] text-neutral-400 mb-3">SIZE</div>
                <div className="flex gap-2 flex-wrap">
                  {p.sizes.map((s) => (
                    <button
                      key={s}
                      onClick={() => setSize(s)}
                      className={`w-11 h-11 border ${size===s ? "border-[var(--accent)] text-[var(--accent)]" : "border-neutral-700 text-neutral-300"} font-mono-label text-xs hover:border-white`}
                      data-testid={`size-${s}`}
                    >
                      {s}
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div className="mb-8">
              <div className="font-mono-label text-[10px] text-neutral-400 mb-3">QUANTITY</div>
              <div className="inline-flex items-center border border-neutral-800">
                <button onClick={() => setQty((q) => Math.max(1, q - 1))} className="w-11 h-11 hover:bg-neutral-900" data-testid="qty-minus"><Minus size={14} className="mx-auto" /></button>
                <span className="w-12 text-center font-headline" data-testid="qty-display">{qty}</span>
                <button onClick={() => setQty((q) => q + 1)} className="w-11 h-11 hover:bg-neutral-900" data-testid="qty-plus"><Plus size={14} className="mx-auto" /></button>
              </div>
            </div>

            <div className="flex gap-3 flex-wrap">
              <button onClick={handleAdd} className="btn-primary" data-testid="add-to-cart-btn">
                <ShoppingBag size={16} /> {added ? "Added!" : "Add to Cart"}
              </button>
              <Link to="/cart" className="btn-ghost" data-testid="view-cart-link">View Cart</Link>
            </div>

            <div className="mt-10 font-mono-label text-[10px] text-neutral-500">
              IN STOCK · {p.stock} UNITS · SHIPS WORLDWIDE
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
